import { InvalidProjectError } from '../../domain/errors/InvalidProjectError';
import type { ProjectsRepository } from '../../domain/repositories/ProjectsRepository.interface';
import type { ProjectDto } from '../dto/ProjectDto';
import { ApplicationError, type Logger } from '@dma/shared';

export class GetProjectsUseCase {
  constructor(
    private readonly repository: ProjectsRepository,
    private readonly logger: Logger
  ) {}

  public async execute(): Promise<ProjectDto[]> {
    try {
      const projects = await this.repository.getAll();
      return projects.map((project) => project.props);
    } catch (error) {
      if (error instanceof InvalidProjectError) {
        this.logger.error('Projects content failed domain validation', {
          code: error.code,
          message: error.message
        });
        throw new ApplicationError('PROJECTS_UNAVAILABLE', 'فهرست پروژه‌ها در حال حاضر در دسترس نیست.', {
          cause: error
        });
      }
      throw error;
    }
  }
}
